import { render } from "./index.vue?vue&type=template&id=7f530f2b&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=7f530f2b&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f530f2b"]])

export default __exports__